<template>
	<el-card
		:body-style="{
			alignItems: 'center',
			padding: '0 18px'
		}"
		class="art"
		shadow="never"
	>
		<span class="text">*请点击字母前的圆圈选择本题正确答案</span>
		<div class="right">
			<span class="text">正确项：</span>
			<div class="option">
				<img src="@/assets/image/color.svg" />
				<el-color-picker v-model="colors[0][colors[0].length]"></el-color-picker>
			</div>

			<div v-for="(item, index) in colors[0]" :key="item" :style="{ background: item }" class="option">
				<div class="close" @click="colors[0].splice(index, 1)">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</div>

		<div class="interfere">
			<span class="text">干扰项：</span>
			<div class="option">
				<img src="@/assets/image/color.svg" />
				<el-color-picker v-model="colors[1][colors[1].length]"></el-color-picker>
			</div>

			<div v-for="(item, index) in colors[1]" :key="item" :style="{ background: item }" class="option">
				<div class="close" @click="colors[1].splice(index, 1)">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</div>
	</el-card>
</template>

<script>
export default {
	name: 'art',
	props: {
		color: {
			type: Array,
			default: () => [[], []],
			required: true
		}
	},
	data() {
		return {
			//
		}
	},
	computed: {
		colors: {
			get() {
				return this.color
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .el-color-picker {
	position: absolute;
	opacity: 0;
	width: 100%;
	height: 100%;

	.el-color-picker__trigger {
		width: 100%;
		height: 100%;
	}
}

.art {
	border-color: rgba(0, 0, 0, 0.2) !important;
}

.option {
	width: 52px;
	height: 52px;
	border-radius: 6px;
	border: 1px solid #d7d7d7;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	margin: 7px 10px;
}

.close {
	width: 16px;
	height: 16px;
	background-color: rgb(219, 219, 219);
	position: absolute;
	right: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100%;
	transform: translateX(30%) translateY(-30%);
	color: white;
	cursor: pointer;
}
.right,
.interfere {
	margin: 26px 0;
	display: flex;
}

.right {
	margin-top: 40px;
}
.text {
	color: #908f8f;
	font-size: 14px;
	line-height: 28 px;
}
</style>
